import type { TabOption } from '@/components/chariot-ui';

/**
 * Attack section tab identifiers.
 */
export enum AttacksTab {
  ATTACK_PATHS = 'attack-paths',
  CAPABILITIES = 'capabilities',
  TEMPLATE_REFINEMENT = 'template-refinement',
  RED_TEAM = 'red-team',
  PHISHING = 'phishing',
  OSINT = 'osint',
}

/**
 * Extended tab option with Praetorian access requirement.
 */
export interface AttackTabOption extends TabOption {
  requiresPraetorian?: boolean;
}

/**
 * Tab options for the attacks section navigation.
 * Tabs with requiresPraetorian: true will show a locked screen for non-Praetorian users.
 */
export const attacksTabs: AttackTabOption[] = [
  { label: 'Attack Paths', value: AttacksTab.ATTACK_PATHS },
  {
    label: 'Capabilities',
    value: AttacksTab.CAPABILITIES,
    requiresPraetorian: true,
  },
  {
    label: 'Signatures',
    value: AttacksTab.TEMPLATE_REFINEMENT,
    requiresPraetorian: true,
  },
  { label: 'Red Team', value: AttacksTab.RED_TEAM, requiresPraetorian: true },
  { label: 'Phishing', value: AttacksTab.PHISHING, requiresPraetorian: true },
  { label: 'Juicy Fruit', value: AttacksTab.OSINT, requiresPraetorian: true },
];

/**
 * Tabs that should only be visible to Praetorian users.
 * @deprecated Use requiresPraetorian property on attacksTabs instead.
 */
export const praetorianOnlyTabs = [
  AttacksTab.CAPABILITIES,
  AttacksTab.TEMPLATE_REFINEMENT,
  AttacksTab.RED_TEAM,
];
